export default (title = '') =>
  title
    .replace(/ \[[a-zA-ZÀ-ž\. ]+\]$/g, '')
    .replace(/ \([a-zA-ZÀ-ž\. ]+\)$/g, '')
    .trimRight()
    .trimLeft()
